export const createPatternValidatorForEnum = (enumObj: Record<string, string>) => {
  const enumValues = Object.values(enumObj).sort();
  return {
    value: new RegExp(`${enumValues.join('|')}`),
    message: `Please select one of the following: ${enumValues.join(', ')}`,
  };
};
